import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propFunc, propNumber, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import RfpOneDescriptionLeftColumn from './RfpOneDescriptionLeftColumn';
import RfpOneDescriptionRightColumn from './RfpOneDescriptionRightColumn';
const RfpOneDescriptionRow = (props) => {
    const { averagePeriod, averagePrice, driverTargetOneRef, isActiveDriverTarget, isSingleOffer, mainClass, onClickDownload, onClickDriverTarget, onClickThumbnail, viewRequest, } = props;
    return (_jsx("div", Object.assign({ className: 'rfp-one-description' }, { children: _jsxs("div", Object.assign({ className: 'description_row' }, { children: [_jsx(RfpOneDescriptionLeftColumn, { driverTargetOneRef: driverTargetOneRef, isActiveDriverTarget: isActiveDriverTarget, onClickDownload: onClickDownload, onClickDriverTarget: onClickDriverTarget, onClickThumbnail: onClickThumbnail, viewRequest: viewRequest }), _jsx(RfpOneDescriptionRightColumn, { averagePeriod: averagePeriod, averagePrice: averagePrice, isSingleOffer: isSingleOffer, mainClass: mainClass, viewRequest: viewRequest })] })) })));
};
RfpOneDescriptionRow.propTypes = {
    averagePeriod: propNumber().isRequired,
    averagePrice: propNumber().isRequired,
    driverTargetOneRef: propShape(),
    isActiveDriverTarget: propBool(),
    isSingleOffer: propBool().isRequired,
    mainClass: propStr().isRequired,
    onClickDownload: propFunc().isRequired,
    onClickDriverTarget: propFunc(),
    onClickThumbnail: propFunc().isRequired,
    viewRequest: propShape().isRequired,
};
RfpOneDescriptionRow.defaultProps = {
    driverTargetOneRef: null,
    isActiveDriverTarget: false,
    onClickDriverTarget: undefined,
};
export default RfpOneDescriptionRow;
